<div class="provider-card box">
  <div class="provider-card__body">
    <div
      class="provider-card__image"
      [ngStyle]="{ 'background-color': brandColor || null }"
    >
      <img [src]="providerImageUrl" [alt]="provider.providerName" />
    </div>
    <h2 class="h3">{{ provider.providerName }}</h2>
  </div>
  <div class="provider-card__footer">
    <a
      [href]="providerUrl"
      (click)="trackLinkClicked()"
      df-button
      dfButtonType="passive"
      df-button-small
      data-dgat="provider-card-048"
      class="provider-card__action-link guts-m-r-half"
    >
      {{ 'Core_FindContent' | translate }}
    </a>
    <a
      *ngIf="provider.baseUrl"
      class="provider-card__action-link color-ebony-a61"
      target="_blank"
      df-button
      dfButtonType="passive"
      df-button-small
      [href]="provider.baseUrl"
      [ngbTooltip]="
        'dgBrowseProviders_VisitSiteFormat'
          | translate: { siteName: provider.providerName }
      "
      data-dgat="browseProviders-8a2"
    >
      <df-icon size="small" icon="arrow-up-right-out"></df-icon>
    </a>
    <dgx-menu
      *ngIf="isEditing"
      [menuConfig]="menuConfig"
      placement="bottom-right"
      [appendToBody]="true"
      class="provider-card__menu"
    >
      <button
        type="button"
        [attr.aria-label]="'Core_MoreOptions' | translate"
        class="provider-card__menu"
        data-dgat="provider-bubble-599"
      >
        <df-icon icon="dots" class="color-ebony-a61 absolute"></df-icon>
      </button>
    </dgx-menu>
  </div>
</div>
